// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__1MDd4","branding":"footer_branding__NIOFb"};